<div class="container mt-4">

    <!-- Button principal -->
    <div class="row justify-content-center">
        <div class="col-md-7 col-xl-5 text-end">
            <a [routerLink]="['/create-bio']" class="btn btn-big">Crear nueva minibio</a>
        </div>
    </div>


    <!-- Contenido -->
    <div class="row justify-content-center">
        <div class="col-md-7 col-xl-5 text-end">

            <div class="mcard" *ngFor="let item of allBios">

                <div class="d-flex bd-highlight">
                    <div class="p-2 flex-grow-1 bd-highlight text-start align-self-center">
                        <h1>{{item.title}}</h1>
                    </div>
                    <div class="p-2 flex-shrink-1 bd-highlight">
                        <button type="button" (click)="visit(item.id)" class="btn btn-primary">Visitar</button>

                        <div class="btn-group">
                            <button type="button" class="btn btn-secondary btn-dots dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                              <img src="../../assets/img/more.svg" alt="más">
                            </button>
                            <ul class="dropdown-menu">
                                <li><button class="dropdown-item" (click)="editBio(item.id)">Editar</button></li>
                                <li><button class="dropdown-item" (click)="deleteBio(item.id)">Eliminar</button></li>
                            </ul>
                        </div>

                    </div>
                </div>

                <div class="d-flex bd-highlight">
                    <p class="p-2">{{item.description}}</p>
                </div>

            </div>

        </div>
    </div>


</div>